import { forwardRef, Inject, Injectable } from '@angular/core';
import { EduContent } from '@campus/dal';
import { ContentActionInterface } from '../..';
import {
  ContentTaskActionsServiceInterface,
  ContentTaskManagerInterface,
  CONTENT_TASK_MANAGER_TOKEN,
} from './content-task-actions.service.interface';

@Injectable({
  providedIn: 'root',
})
export class ContentTaskActionsStudentService implements ContentTaskActionsServiceInterface {
  constructor(
    @Inject(forwardRef(() => CONTENT_TASK_MANAGER_TOKEN))
    private contentTaskManager: ContentTaskManagerInterface
  ) {}

  private contentTaskActionDictionary: {
    [key: string]: ContentActionInterface;
  } = {};

  public getTaskActionsForEduContent(eduContent: EduContent, inTask: boolean): ContentActionInterface[] {
    return [];
  }
}
